import { PropertiesDetailPage } from '@/features/properties/pages/properties-detail-page';

export const PropertiesDetailRoute = () => {
  return <PropertiesDetailPage />;
};
